/**
 * ราคา (Pricing) — ราคาสินค้าแต่ละหน่วย (ชิ้น/ชุด) ที่บอตใช้คำนวณตอนลูกค้าสั่ง
 * เชื่อมกับ: โปรโมชั่น (ลดจากราคานี้) · ทดสอบบอต ("รับ 1 ชุด" → คำนวณ)
 *
 * ใช้ CrudManager กลาง — ราคาเก็บเป็นสตางค์ใน DB แต่กรอกเป็นบาท (field money)
 */
import { CrudManager, type CrudField } from '@/components/CrudManager';
import { PricingApi, type PricingItem } from '@/lib/admin-api';

const UNIT_TYPES = [
  { value: 'piece', label: 'ชิ้น (piece)' },
  { value: 'bundle', label: 'ชุด (bundle)' },
];

const FIELDS: CrudField[] = [
  { key: 'itemKey', label: 'รหัสสินค้า (key)', type: 'text', required: true, placeholder: 'shirt / scrub_set', disabledOnEdit: true, help: 'ตัวระบุภายใน ใช้ผูกกับโปร/รูป ห้ามเปลี่ยน' },
  { key: 'label', label: 'ชื่อแสดง', type: 'text', required: true, placeholder: 'เสื้อ Scrub', help: 'ชื่อที่คนอ่านเข้าใจ' },
  { key: 'unitType', label: 'ประเภทหน่วย', type: 'select', required: true, options: UNIT_TYPES, default: 'piece', disabledOnEdit: true, help: 'ชิ้นเดียว หรือ ชุด (หลายชิ้น)' },
  { key: 'piecesPerUnit', label: 'กี่ชิ้นต่อหน่วย', type: 'number', default: 1, disabledOnEdit: true, help: 'ชุด = 2, ชิ้น = 1' },
  { key: 'price', label: 'ราคา', type: 'number', money: true, required: true, help: 'ราคาต่อหน่วย (บาท)' },
  { key: 'sortOrder', label: 'ลำดับ', type: 'number', default: 0, help: 'เลขน้อยขึ้นก่อน' },
  { key: 'active', label: 'เปิดใช้งาน', type: 'toggle', default: true },
  { key: 'notes', label: 'หมายเหตุ', type: 'text', help: 'บันทึกภายใน' },
];

export default function PricingPage() {
  return (
    <CrudManager<PricingItem>
      title="💰 ราคา (Pricing)"
      addLabel="เพิ่มสินค้า"
      help="ราคาต่อหน่วยที่บอตใช้คำนวณตอนลูกค้าสั่ง (โปรจะลดจากราคานี้). กรอกเป็นบาท ระบบเก็บเป็นสตางค์ให้อัตโนมัติ"
      queryKey="pricing"
      api={PricingApi}
      fields={FIELDS}
      brandScoped
      searchKeys={['itemKey', 'label']}
      sortRows={(a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0) || a.id - b.id}
      rowTitle={(p) => <>{p.label}</>}
      rowSubtitle={(p) => <>รหัส: <code>{p.itemKey}</code> · {p.unitType === 'bundle' ? `ชุด ${p.piecesPerUnit} ชิ้น` : 'ชิ้นเดียว'} · {(p.price / 100).toLocaleString()} ฿</>}
    />
  );
}
